import styled from 'styled-components'

export const BudgetNameWrapStyled = styled.div`
  display: block;
  overflow-wrap: anywhere;
  min-width: 0;
`
